module.exports = __webpack_public_path__ + "assets/lessons/hr/lesson5/pages/lesson_5_03.pdf";